import { type ComponentProps, type ReactNode } from "react";

import { cn } from "@oneleet/utils";

import * as RadixLabel from "@radix-ui/react-label";
import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";

const formLabel = cva(
  "text-ng-md font-ng-medium inline-block text-neutral-950",
);

type LabelVariantProps = VariantProps<typeof formLabel>;

export type Props = LabelVariantProps & {
  htmlFor?: string;
  className?: string;
  children: ReactNode;
} & ComponentProps<typeof RadixLabel.Root>;

export const NgFormLabel = ({
  className,
  ref,
  ...props
}: React.ComponentProps<typeof RadixLabel.Root>) => {
  return (
    <RadixLabel.Root
      className={cn(formLabel({ className }))}
      {...props}
      ref={ref}
    />
  );
};

NgFormLabel.displayName = "NgFormLabel";
